import type { ReactNode } from 'react';

type HeroLabelProps = {
  children: ReactNode;
};

export function HeroLabel({ children }: HeroLabelProps) {
  return (
    <div className="hero-label">
      <span className="tick" aria-hidden="true" />
      {children}
    </div>
  );
}
